import { useEffect } from "react";
import { SITE_URL, TRACKING_PATH_PREFIX } from "../components/Siteconfig";
import { upsertMeta, upsertCanonical } from "../utils/seo";
export default function useCourseSEO(course) {
  useEffect(() => {
    if (!course) return;
    const seo = course.detail?.seo || {};
    const title =
      seo.title || `${course.name} Course Online | Live Classes | What Next`;
    const description =
      seo.metaDescription ||
      `Learn ${course.name} online through live mentor-led classes with practical, project-based training from What Next.`;
    const courseKey = course.slug || course.id;
    const canonicalUrl = `${SITE_URL}/courses/${courseKey}`;
    const trackingPath = `${TRACKING_PATH_PREFIX}/courses/${courseKey}`;
    document.title = title;
    upsertMeta("description", description);
    upsertCanonical(canonicalUrl);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: trackingPath,
      page_title: title,
      course_id: courseKey,
    });
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: trackingPath,
        page_title: title,
      });
    }
  }, [course]);
}
export function useHomeSEO() {
  useEffect(() => {
    const title =
      "Live Online Classes | Python, Java, Full Stack, AI & Data Analytics | What Next";
    const description =
      "Join live online classes led by industry mentors. Learn Python, Java, Full Stack Development, Data Analytics, AI, Digital Marketing and more through interactive online learning.";
    document.title = title;
    upsertMeta("description", description);
    upsertCanonical(`${SITE_URL}/`);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: `${TRACKING_PATH_PREFIX}/`,
      page_title: title,
    });
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: `${TRACKING_PATH_PREFIX}/`,
        page_title: title,
      });
    }
  }, []);
}